/* eslint-disable unicorn/prevent-abbreviations */
const watch = name => (target, key, descriptor) => {
	console.log('descriptor', descriptor);
	console.log('target', target);
	console.log('key', key);
	// const fn = descriptor.value;
	// descriptor.value = (...rest) => {
	// 	console.log('this', this);
	// 	this.toWatch.push({
	// 		name,
	// 		fn: Reflect.apply(fn, this, ...rest),
	// 	});
	// };
};
/**
 * @ngdoc function
 * @name app.controller:Dev4Ctrl
 * @description
 * # Dev4Ctrl
 * Controller of the app
 */
export default class {
	/* @ngInject */
	constructor($scope) {
		this.$scope = $scope;
		this.$scope.toWatch = [];
		this.$scope.clicks = 0;
		this.$scope.increment = () => {
			console.log('increment');
			this.$scope.clicks += 1;
		};

		this.$scope.$watch('toWatch', () => {
			console.log('this.$scope.toWatch', this.$scope.toWatch);
		});

		this.model = `
		<p class="pm-align--left"><strong>Bold</strong></p>
		<p class="pm-align--left"><em>Italic</em></p>
		<p class="pm-align--left"><em><u>Underlined</u></em></p>
		<p class="pm-align--left">Left</p>
		<p class="pm-align--right">Right</p>
		<p class="pm-align--center">Center</p>
		<p class="pm-align--justify">Justify</p>
		<pre><code>this.$scope.$watch('toWatch', () => {
    console.log('this.$scope.toWatch', this.$scope.toWatch);
});</code></pre>
		`;

		this.model2 = `
		<p class="pm-align--left"><strong>Bold</strong></p>
		<p class="pm-align--left"><em>Italic</em></p>
		<p class="pm-align--left"><em><u>Underlined</u></em></p>
		<p class="pm-align--left">Left</p>
		<p class="pm-align--right">Right</p>
		<p class="pm-align--center">Center</p>
		<p class="pm-align--justify">Justify</p>
		<a kid="K_NODE;PERSON"></a>
		<pre lang="js"><code>this.$scope.$watch('toWatch', () => {
    console.log('this.$scope.toWatch', this.$scope.toWatch);
});</code></pre>
		`;
	}

	// @watch('clicks')
	// onClickChange() {
	// 	console.log('clicked!');
	// }
}
